const initialState = {
  status: "invalid",
  data: null,
  meta: null,
};

function PlatformTaxonReducer(state = initialState, action) {
  switch (action.type) {
    case "PLATFORM_TAXONS_LOADING":
      return {
        status: "loading",
      };
    case "PLATFORM_TAXONS_SUCCESS":
      return {
        ...state,
        status: "success",
        data: action.data,
        meta: action.meta,
      };
    case "PLATFORM_TAXONS_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
}

export default PlatformTaxonReducer;
